import { toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", { class: "badge bg-primary ms-2" }, _toDisplayString(_ctx.cart_counter), 513 /* TEXT, NEED_PATCH */)), [
    [_vShow, _ctx.cart_counter > 0]
  ])
}